export default "__VITE_ASSET__Cbjf2D8K__"